




































import { Dialog } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const couponModule = namespace("coupon");

@Component
export default class CouponVerification extends Vue {
	couponDetail: any = {
		writeOffTime: "",
		couponMainInfo: "",
		couponExtendInfo: "",
		couponInstanceQrCode: "",
		couponActivityName: ""
	};
	//effectiveCouponEntity
	// couponDetail: any = {}
	member: string = "";
	entityName: string = "";
	writeOffTime: string | (string | null)[] = "";

	mounted() {
		this.renderData();
		this.member = this.$global.uName;
		this.entityName = this.$global.tenantName;
		this.getCouponID();
	}
	renderData() {
		const couponDetail: any = this.$route.query;
		this.couponDetail.couponMainInfo = couponDetail.couponMainInfo;
		this.couponDetail.couponExtendInfo = couponDetail.couponExtendInfo;
		this.couponDetail.couponInstanceQrCode =
			couponDetail.couponInstanceQrCode;
		this.couponDetail.couponActivityName = couponDetail.couponActivityName;
		this.couponDetail.writeOffTime = couponDetail.writeOffTime;

		if (this.$global.routes.indexOf("/linkedOrder") >= 0) {
			Dialog.confirm({
				title: "核销成功",
				message: "是否需要将本优惠券关联到订单?"
			})
				.then(() => {
					this.$router.replace(
						"/linkedOrder?qrCode=" + couponDetail.qrCode
					);
				})
				.catch(() => {});
		}
	}
	getCouponID() {
		this.$store.commit("coupon/setcouponSearchStep", 3);
	}
	handleConfirmClick() {
		this.$router.push(`/home`);
	}
}
